import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { EnumUserType, enumusertypeToI18nKey } from "../../../generated/enums";

const USER_TYPE_STYLES: Record<
  EnumUserType,
  { icon: IconProp; className: string }
> = {
  admin: {
    icon: "user-shield",
    className: "bg-red-500 text-secondary-text",
  },
  psc: {
    icon: "user-tie",
    className: "bg-secondary text-secondary-text",
  },
  breeder: {
    icon: "seedling",
    className: "bg-tertiary text-secondary-text",
  },
  breeder_assistant: {
    icon: "user-friends",
    className: "bg-grey-dark text-secondary-text",
  },
  installer: {
    icon: "screwdriver-wrench",
    className: "bg-warning text-secondary-text",
  },
  installer_assistant: {
    icon: "tools",
    className: "bg-grey-medium text-secondary-text",
  },
  group: {
    icon: "users",
    className: "bg-grey-light text-default-text",
  },
  group_assistant: {
    icon: "user-friends",
    className: "bg-grey-light text-default-text",
  },
};

export const UserTypeBadge = ({ type }: { type: EnumUserType }) => {
  const { t } = useTranslation();
  const style = USER_TYPE_STYLES[type];

  return (
    <span
      className={`inline-flex items-center gap-2 px-2 py-0.5 rounded-full text-xs font-oxaniumMedium ${style.className}`}
    >
      <FontAwesomeIcon icon={style.icon} />
      <span>{t(enumusertypeToI18nKey[type])}</span>
    </span>
  );
};
